import { render, staticRenderFns } from "./SupplyFormAddress.vue?vue&type=template&id=048f8469&"
import script from "./SupplyFormAddress.vue?vue&type=script&lang=js&"
export * from "./SupplyFormAddress.vue?vue&type=script&lang=js&"
import style0 from "./SupplyFormAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports